module.exports = "https://cdn.dove.it/_next/static/public/assets/press/logo-corrieredellasera.527d21408041039d7a24fd0da099992e.png";